/**
 * ledgerClaimName
 *
 * A claim named in words: "<match group>, <claim kind>", as "M-3101, Basic commission", the match group being the
 * claim's own and the kind its label in the definition. A claim kind the definition no longer declares names itself by its
 * id, so a retired kind still reads. Consumers: `ledgerProposalProblem`, which names a claim it cannot find in its own
 * words, and `LedgerProposalClaimText` in react, which shows it above the raw claim id.
 */

import type { LedgerDefinition } from '../System.Ledger.Definition.types';
import type { LedgerMatchClaim } from './LedgerMatching.types';

export const ledgerClaimName = (
    definition: Pick<LedgerDefinition, 'claimKinds'>,
    claim: Pick<LedgerMatchClaim, 'matchGroup' | 'claimKindId'>,
): string => {
    const kind = definition.claimKinds.find((candidate) => candidate.claimKindId === claim.claimKindId);
    return `${claim.matchGroup}, ${kind?.label ?? claim.claimKindId}`;
};
